import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  Divider,
  Icon,
} from '@chakra-ui/react'
import { LuUserPlus } from 'react-icons/lu'
import Plus from '../../../assets/svg/plus'
import PatientForm from '../../Forms/patientForm'
import { useTranslation } from 'react-i18next'

export default function PatientFormModal() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { t } = useTranslation()

  return (
    <>
      <Button
        onClick={onOpen}
        leftIcon={<Plus />}
        bg="brand.purple"
        colorScheme="purple"
        size="lg"
        fontWeight={600}
        borderRadius="xl"
        px={8}
        _hover={{
          transform: 'translateY(-2px)',
          boxShadow: 'xl',
        }}
        transition="all 0.2s"
      >
        {t('home.addPatient')}
      </Button>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="6xl"
        motionPreset="slideInBottom"
      >
        <Box fontFamily={'Poppins'}>
          <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.600" />
          <ModalContent
            borderRadius="2xl"
            boxShadow="2xl"
            maxW="70%"
            overflow="hidden"
          >
            <ModalHeader
              bgGradient="linear(135deg, brand.purple 0%, purple.500 50%, pink.400 100%)"
              color="white"
              py={6}
              px={8}
            >
              <Box display="flex" alignItems="center" gap={3}>
                <Icon as={LuUserPlus} boxSize={7} />
                <Box>
                  <Text fontSize="2xl" fontWeight={600} mb={1}>
                    {t('patient.newPatient')}
                  </Text>
                  <Text fontSize="sm" fontWeight={400} opacity={0.9}>
                    {t('patient.newPatientInfo')}
                  </Text>
                </Box>
              </Box>
            </ModalHeader>
            <ModalCloseButton
              color="white"
              size="lg"
              _hover={{ bg: 'whiteAlpha.300' }}
            />
            <Divider />
            <ModalBody px={8} py={8} bg="gray.50">
              <PatientForm onClose={onClose} />
            </ModalBody>
          </ModalContent>
        </Box>
      </Modal>
    </>
  )
}
